// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list {
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  gap: 50px;
  flex-wrap: wrap;
}

.available {
  width: 350px;
  max-width: 50%;
  height: 210px;
  background-color: white;
  /* box-shadow: 2px 8px 20px rgb(241, 237, 237); */
  transition: 0.5s linear;
  padding: 0px;
  border: 1px solid #eeeeee;
  margin: auto 5px;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  text-align: center;
  overflow-y: scroll;
}

.available > h4 {
  margin: 0px;
  width: 100%;
  padding: 15px;
  text-align: center;
  background-color: #3b4e60;
  color: #fff;
}

.item {
  cursor: pointer;
  border-bottom: 1px solid #cfcdcd;
  width: 100%;
  padding: 8px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item:hover {
  background-color: #29b6f6;
  color: #fff;
  border: 1px solid #000;
}

.flex-sre {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
}
.margin-top-40 {
  margin-top: 40px;
}

.react-datepicker__input-container input {
  border: 1px solid #c9d6de;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./client/components/dashboard/SearchOps/searchRuleEngine/list.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,iDAAiD;EACjD,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".list {\n  display: flex;\n  width: 100%;\n  margin-top: 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 50px;\n  flex-wrap: wrap;\n}\n\n.available {\n  width: 350px;\n  max-width: 50%;\n  height: 210px;\n  background-color: white;\n  /* box-shadow: 2px 8px 20px rgb(241, 237, 237); */\n  transition: 0.5s linear;\n  padding: 0px;\n  border: 1px solid #eeeeee;\n  margin: auto 5px;\n  display: flex;\n  flex-direction: column;\n  /* justify-content: center; */\n  align-items: center;\n  text-align: center;\n  overflow-y: scroll;\n}\n\n.available > h4 {\n  margin: 0px;\n  width: 100%;\n  padding: 15px;\n  text-align: center;\n  background-color: #3b4e60;\n  color: #fff;\n}\n\n.item {\n  cursor: pointer;\n  border-bottom: 1px solid #cfcdcd;\n  width: 100%;\n  padding: 8px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.item:hover {\n  background-color: #29b6f6;\n  color: #fff;\n  border: 1px solid #000;\n}\n\n.flex-sre {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n.margin-top-40 {\n  margin-top: 40px;\n}\n\n.react-datepicker__input-container input {\n  border: 1px solid #c9d6de;\n  height: 30px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
